import styled from '@emotion/styled';
import {Link} from 'react-router-dom';
import {Button, Table} from '@mui/joy';
import {ellipsisStyle} from '../../styles';

// Define the dimensions for the action button used in the table
const ACTION_BUTTON_CONSTANTS = {
  width: 104,
  height: 40,
  horizontalPadding: 8, // 8px right + 0px left
  verticalPadding: 12, // 6px top + 6px bottom
};

const ACTION_COLUMN_WIDTH =
  ACTION_BUTTON_CONSTANTS.width + ACTION_BUTTON_CONSTANTS.horizontalPadding;
const ROW_MIN_HEIGHT =
  ACTION_BUTTON_CONSTANTS.height + ACTION_BUTTON_CONSTANTS.verticalPadding;

export const TableWrapper = styled(Table)`
  border-spacing: 0 8px;
`;

export const TableHeaderItem = styled.th`
  background-color: ${({theme}) => theme.color.neutral.grey_50} !important;

  p {
    ${ellipsisStyle}
  }
`;

export const ActionColumnHeaderItem = styled(TableHeaderItem)`
  // Ensure the column has the smallest width possible
  width: ${ACTION_COLUMN_WIDTH}px;
`;

export const TableRowBase = styled.tr`
  // Ensure the row has a minimum height to accommodate the button
  height: ${ROW_MIN_HEIGHT}px;
`;

export const TableRow = styled(TableRowBase)`
  :hover {
    background-color: ${({theme}) => theme.color.primary_10};
    font-weight: ${({theme}) => theme.typography.fontWeight.bold};
  }
`;

export const ActionButtonWrapper = styled.td`
  padding: ${({
    theme: {
      padding: {desktop},
    },
  }) => `${desktop.xxs} ${desktop.xs} ${desktop.xxs} 0`} !important;
`;

export const DeferButton = styled(Button)`
  width: 100%;
  height: 100%;
  border-radius: ${({theme}) => theme.border.radius.xxs};
`;

// For Table with clickable rows
export const ClickableTableCell = styled.td`
  position: relative;
  cursor: pointer;
`;

export const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  padding: ${({theme}) =>
    `${theme.padding.desktop.xxs} ${theme.padding.desktop.xs}`};
  text-decoration: none;
`;
